// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1022":"9fd423d3","3137":"7cae88fc","5439":"9fd423d3"}[chunkId] + ".chunk.css";
};